import { component_tool, utils_tool } from '@/tool';
import React from 'react';
import RealTrain from './realTrain';
import DpStateSet from './dpStateSet';
import "./index.less";
import moment from 'moment';

let { WizModal, WizSurveyAudience, WizTypography, WizRow, WizDataTable, WizButton, WizAlert } = component_tool;
let { $$, checkStrLength, Storage } = utils_tool;

import { WizTableForm } from "../../../common";
import UpdatePersonnelState from "./updatePersonnelState";
import UpdatePositionAuthState from "./updatePositionAuthState";
import InitDealerNewPersonTrainDetail from "./initDealerNewPersonTrainDetail";
const positionConfig = WizTableForm.Config.position(this, { apiParams: { state: 1 } })
let ref
let ref_
let ref2_;
//配置项
let componentName = 'requirementOrgPerson' // requirementOrgPerson requirementPersonnelDetail
const columns = ({ type = null }, _this, data) => {
  let columns = [
    {
      name: "id",
      formItem: {
        type: "hidden"
      }
    },
    {
      title: "岗位名称",
      name: "positionName",
      dataIndex: "positionName",
      tableItem: { width: 150 },
    },
    {
      title: "姓名",
      name: "fullName",
      dataIndex: "fullName",
      tableItem: { width: 80 },
    },
    {
      title: "姓名",
      name: "fullNameSearch",
      dataIndex: "fullNameSearch",
      searchItem: {

      }
    },
    {
      title: "账号",
      name: "userNameSearch",
      dataIndex: "userNameSearch",
      searchItem: {

      }
    },
    {
      title: "账号",
      name: "userName",
      dataIndex: "userName",
      tableItem: { width: 180 }
    },
    {
      title: "任职状态",
      name: "jobState",
      dataIndex: "jobState",
      tableItem: { width: 100 },
      dict: [
        { code: 0, codeName: "离职" },
        { code: 1, codeName: "在职" },
      ],
      searchItem: {
        type: 'select'
      }
    },
    {
      title: '岗位名称',
      name: 'positionIdList',
      searchItem: {
          ...positionConfig,
          diy: WizTableForm
      }
    },
    {
      title: "创建时间",
      name: "createTime",
      dataIndex: "createTime",
      tableItem: { width: 180 }
    },
    {
      title: "新店/老店新人",
      name: "personStatus",
      dataIndex: "personStatus",
      tableItem: { width: 120 },
      dict: [
        { code: 0, codeName: "新店新人" },
        { code: 1, codeName: "老店新人" },
      ],
    },
    {
      title: "实际培训状态",
      name: "trainFactStatus",
      dataIndex: "trainFactStatus",
      tableItem: { width: 100 },
      dict: [
        { code: 0, codeName: "培训中" },
        { code: 1, codeName: "已通过" },
      ],
      searchItem: {
        type: 'select'
      }
    },
    {
      title: "DP状态",
      name: "trainDpStatus",
      dataIndex: "trainDpStatus",
      tableItem: { width: 80 },
      dict: [
        { code: 0, codeName: "未通过" },
        { code: 1, codeName: "已通过" },
        { code: 2, codeName: "培训中" },
      ],
      searchItem: {
        type: 'select'
      }
    },
    {
      title: "推送状态",
      name: "pushStatus",
      dataIndex: "pushStatus",
      tableItem: { width: 100 },
      dict: [
        { code: 0, codeName: "待推送" },
        { code: 1, codeName: "已推送" },
        { code: 2, codeName: "" },
      ],
      searchItem: {
        type: 'select'
      }
    },
    {
      title: "推送时间",
      name: "pushTime",
      dataIndex: "pushTime",
      tableItem: { width: 180 },
    },
    {
      title: '推送时间',
      name: 'pushDate',
      dataIndex: "pushDate",
      searchItem: {
        type: 'date~',
        showTime: true
      },
    },
    {
      title: "DP任职标识",
      name: "dpMark",
      dataIndex: "dpMark",
      tableItem: {},
      dict: [
        { code: "DP新下发", codeName: "DP新下发" },
        { code: "DP反馈离职", codeName: "DP反馈离职" },
        { code: "DP历史下发", codeName: "DP历史下发" },
        { code: "DP兼职处理", codeName: "DP兼职处理" },
      ],
    },
    {
      title: "DP任职标识",
      name: "dpMarkList",
      dataIndex: "dpMarkList",
      dict: [
        { code: "DP新下发", codeName: "DP新下发" },
        { code: "DP反馈离职", codeName: "DP反馈离职" },
        { code: "DP历史下发", codeName: "DP历史下发" },
        { code: "DP兼职处理", codeName: "DP兼职处理" },
      ],
      searchItem: {
        type: 'select',
        mode: 'multiple',
      }
    },
    {
      title: "DP状态操作人",
      name: "operatorFullName",
      dataIndex: "operatorFullName",
      tableItem: {},
    },
    {
      title: "DP状态操作类型",
      name: "operateType",
      dataIndex: "operateType",
      tableItem: {},
      dict: [
        { code: 1, codeName: "人工" },
        { code: 2, codeName: "系统" },
      ],
    },
  ];
  return columns;
}

const templateConfig = (trainState, type,isNew,orgId, _this, data) => {
  return {
    mainProps: {},
    content: {
      name: "WizTableList",
      params: {
        columns: columns({ type }, _this, data),
        searchBarProps: {
          dataFormat: (params) => {
            let value = Object.assign({}, params)
            if (value.pushDate && value.pushDate.length === 2) {
              value.pushTimeStart = moment(value.pushDate[0]).format('YYYY-MM-DD HH:mm:ss')
              value.pushTimeEnd = moment(value.pushDate[1]).format('YYYY-MM-DD HH:mm:ss')
            } else {
              value.pushTimeStart = undefined;
              value.pushTimeEnd = undefined;
            }
            _this.setState({ timestamp: new Date().getTime()})
            // delete value.time
            return value
          },
          cols: {
            xs: 24,
            md: 12,
            xl: 8
          },
          collapse: false,
          buttonSort: ['export', 'exportRealTrain', 'exportBTrain','exportBTrainSales','exportBTrainAfterSales','initData'],
          buttons: [
            {
              key: 'export',
              custom: true,
              params: { icon: 'export', children: '导出', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "export",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'exportRealTrain',
              custom: true,
              params: { icon: 'export', children: '导出实际培训情况', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportRealTrain",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'exportDpTrain',
              custom: true,
              params: { icon: 'export', children: '导出DP培训情况', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "exportDpTrain",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { ...filters }
                }
              }
            },
            {
              key: 'exportBTrain',
              custom: true,
              params: { icon: 'export', children: '导出培训B表', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "checkExportRequirementOrgPersonReport",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { }
                }
              },
              recordChangeParams: ({record, rows}) => {
                let hidden = 1;
                if (isNew != null && isNew != undefined && isNew === 1){
                  hidden = 0;
                }
                return {
                  hidden:hidden
                }
              }
            },
            {
              key: 'exportBTrainSales',
              custom: true,
              params: { icon: 'export', children: '导出销售培训B表', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "checkExportRequirementOrgPersonReport",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { salesOrAfterSales:1 }
                }
              },
              recordChangeParams: ({record, rows}) => {
                let hidden = 1;
                if (isNew != null && isNew != undefined && isNew === 1){
                  hidden = 0;
                }
                return {
                  hidden:hidden
                }
              }
            },
            {
              key: 'exportBTrainAfterSales',
              custom: true,
              params: { icon: 'export', children: '导出售后培训B表', type: 'export' },
              customOnClick: {
                key: 'action',
                params: {
                  apiKey: "checkExportRequirementOrgPersonReport",
                  apiParams: {}
                },
                formatParams: (rows, record, filters, callback) => {
                  return { salesOrAfterSales:2 }
                }
              },
              recordChangeParams: ({record, rows}) => {
                let hidden = 1;
                if (isNew != null && isNew != undefined && isNew === 1){
                  hidden = 0;
                }
                return {
                  hidden:hidden
                }
              }
            },
            {
              key: "initData",
              name: "WizButton",
              custom: true,
              params: { icon: 'plus', children: '初始化培训数据', type: 'primary', key: "_btn",},
              customOnClick: {
                key: "modal",
                params: {
                  modalKey:'addModal',
                  modalParams: {
                    title: "初始化培训数据",
                    diy: (e) => {
                      return (
                        <InitDealerNewPersonTrainDetail
                          key={new Date()}
                          {...e}
                          orgId={orgId}
                          ref={r => {
                            ref2_ = r && r.getWrappedInstance();
                          }}
                        />
                      )
                    },

                    onOk: () => {
                      ref2_._initDealerNewPersonTrainDetail()
                    },
                    onCancel: () => {
                    },
                    width: 1000
                  }
                }
              }
            },
          ]
        },
        modalFormProps: {},
        dataTableProps: {
          rowKey: "id",
          //selectType: "checkbox",
          isScroll: true,
          loading: false,
          bordered: false,
          //maxNum: 1
        },
        // rowOperateProps: {
        //   width: 240
        // },
        rowOperateSort: ['realTrain', 'dpTrain', 'updatePersonnelState' , 'updatePositionAuthState', 'dpStateSet','updatePushStatus'],
        rowOperateView: [
          {
            key: "realTrain",
            custom: true,
            params: { children: "实际培训情况" },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  width:700,
                  title: "实际培训情况",
                  diy: (e) => {
                    return (
                      <RealTrain
                        key={'realTrain' + e.record.id+_this.state.timestamp}
                        reportType={0}
                        ref_={(r) => {
                          ref_ = r && r.getWrappedInstance()
                        }}
                        {...e}
                      />
                    )
                  },
                  footer: null,
                }
              },
              formatParams: (rows, record, filter) => {
                return { ...record };
              }
            },
          },
          {
            key: "dpTrain",
            custom: true,
            params: { children: "DP培训情况" },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  width:700,
                  title: "DP培训情况",
                  diy: (e) => {
                    return (
                      <RealTrain
                        key={'dpTrain' + e.record.id+_this.state.timestamp}
                        reportType={1}
                        ref={(r) => {
                          ref = r && r.getWrappedInstance()
                        }}
                        {...e}
                      />
                    )
                  },
                  footer: null,
                }
              },
              formatParams: (rows, record, filter) => {
                return { ...record };
              }
            },
            recordChangeParams: ({ record, rows }) => {
              return {
                 disabled:record.trainDpStatus==2
              }
            }
          },
          {
            key: "updatePersonnelState",
            custom: true,
            params: {children: "测评"},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "测评",
                  diy: (e) => {
                    return (
                      <UpdatePersonnelState
                        onChangeTimestamp={(e) =>
                          _this.setState({ timestamp: new Date().getTime()})}
                        key={'dealerNewPersonTrainDetailRequirements' + e.record.personId+new Date().getTime()}
                        {...e}
                      />
                    )
                  },
                  footer: null,
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            },
            recordChangeParams: ({record, rows}) => {
              return { hidden: !(record.trainDpStatus===2 && record.isPersonnelStateRequirement===1)}
            }
          },
          {
            key: "updatePositionAuthState",
            custom: true,
            params: {children: "岗位认证评分"},
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  title: "岗位认证评分",
                  diy: (e) => {
                    return (
                      <UpdatePositionAuthState
                        onChangeTimestamp={(e) =>
                          _this.setState({ timestamp: new Date().getTime()})}
                        key={'dealerNewPersonTrainDetailRequirements' + e.record.personId+new Date().getTime()}
                        {...e}
                      />
                    )
                  },
                  footer: null,
                }
              },
              formatParams: (rows, record, filter) => {
                return {...record};
              }
            },
            recordChangeParams: ({record, rows}) => {
              return { hidden: !(record.trainDpStatus===2 && record.isPositionAuthRequirement===1)}
            }
          },
          {
            key: "dpStateSet",
            custom: true,
            params: { children: "DP状态设置" },
            customOnClick: {
              key: "modal",
              params: {
                modalParams: {
                  width:700,
                  title: "DP状态设置",
                  diy: (e) => {
                    return (
                      <DpStateSet
                        key={'dpStateSet' + e.record.id}
                        reportType={1}
                        {...e}
                      />
                    )
                  },
                  onCancel: () => {
                  },
                  footer: null,
                }
              },
              formatParams: (rows, record, filter) => {
                return { ...record };
              }
            },
            recordChangeParams: ({ record, rows }) => {
              return {
                 disabled:record.trainDpStatus!=2
              }
            }
          },
          {
            key: "setOldDealerNewPerson",
            custom: true,
            params: { children: "设为老店新人" },
            customOnClick: {
              key: "action",
              params: {
                apiKey: "setOldDealerNewPerson",
                apiParams: {}
              },
              formatParams: (rows, record, filter,callback) => {
                const info = <font color='red'>{record.fullName}（{record.userName}）</font> //钟永强（dp0001）
                const content = <div>
                  您正在将学员{info}， {record.orgName} - {record.positionName}“新店新人”的标识设为“老店新人”，此操作不可逆，标识成功后，学员会根据老店新人的考核要求进行考核，是否确认？
                </div>
                WizModal.confirm({
                  title: '信息确认',
                  content: content,
                  width: 500,
                  onOk: () => {
                    callback && callback({
                      id: record['id'],
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({ record, rows }) => {
              let disabled = true;
              if (record.personStatus === 0 && record.trainDpStatus === 2 && data.oldNewShop === 1) {
                disabled = false
              }
              return {
                disabled
              }
            }
          },
          {
            key: "updatePushStatus",
            custom: true,
            params: { children: "重置推送状态"},
            customOnClick: {
              key: "action",
              params: {
                apiKey: "updatePushStatus",
                apiParams: {}
              },
              formatParams: (rows, record, filters, callback) => {
                const content = `您确定要重置该学员的推送状态吗？`;
                WizModal.confirm({
                  title: '注意', content,
                  onOk: () => {
                    callback && callback({
                      id: record['id']
                    })
                  },
                  onCancel() {
                  }
                });
                return null
              }
            },
            recordChangeParams: ({record, rows}) => {
              return { hidden: !(record.pushStatus===1),disabled: !(record.pushStatus===1)}
            }
          },
        ],
        commonOperate: {
          //add: true,
          //update: true
        }
      }
    }
  }
};

const apis = (record) => {
  const { orgId } = record;
  return {
    list: {
      path: `${componentName}/getListByPage`,
      payload: {
        key: `${componentName}@listByPage`,
        apiParams: { pageNum: 1, pageSize: 10, orgId}
      }
    },
    export: {
      path: `${componentName}/getList`,
      payload: {
        key: `${componentName}@getList`,
        apiParams: { pageNum: 1, pageSize: 10, orgId }
      }
    },
    exportRealTrain: {
      path: `${componentName}/exportRealTrain`,
      payload: {
        key: `${componentName}@exportRealTrain`,
        apiParams: { pageNum: 1, pageSize: 10, orgId ,reportType:0}
      }
    },
    exportDpTrain: {
      path: `${componentName}/exportRealTrain`,
      payload: {
        key: `${componentName}@exportDpTrain`,
        apiParams: { pageNum: 1, pageSize: 10, orgId ,reportType:1}
      }
    },
    exportBTrain: {
      path: `${componentName}/exportRealTrain`,
      payload: {
        key: `${componentName}@exportBTrain`,
        apiParams: { pageNum: 1, pageSize: 10, orgId ,reportType:2}
      }
    },
    exportBTrainSales: {
      path: `${componentName}/exportBTrainSales`,
      payload: {
        key: `${componentName}@exportBTrainSales`,
        apiParams: { pageNum: 1, pageSize: 10, orgId ,reportType:2,salesOrAfterSales:1}
      }
    },
    exportBTrainAfterSales: {
      path: `${componentName}/exportBTrainAfterSales`,
      payload: {
        key: `${componentName}@exportBTrainAfterSales`,
        apiParams: { pageNum: 1, pageSize: 10, orgId ,reportType:2,salesOrAfterSales:2}
      }
    },
    exportRequirementOrgPersonInfoReport: {
      path: `${componentName}/exportRequirementOrgPersonInfoReport`,
      payload: {
        key: `${componentName}@exportRequirementOrgPersonInfoReport`,
        apiParams: { pageNum: 1, pageSize: 10, orgId ,reportType:2}
      }
    },
    checkExportRequirementOrgPersonReport:{
      path: `${componentName}/checkExportRequirementOrgPersonReport`,
      payload: {
        key: `${componentName}@checkExportRequirementOrgPersonReport`,
        apiParams: { pageNum: 1, pageSize: 10, orgId ,reportType:2}
      }
    },
    setOldDealerNewPerson: {
      path: `${componentName}/setOldDealerNewPerson`,
      payload: {
        key: `${componentName}@setOldDealerNewPerson`,
        apiParams: {}
      }
    },
    initRequirementOrgPersonByUserIdentityId:{
      path: `${componentName}/initRequirementOrgPersonByUserIdentityId`,
      payload: {
        key: `${componentName}@initRequirementOrgPersonByUserIdentityId`,
        apiParams: {}
      }
    },
    updatePushStatus:{
      path: `${componentName}/updatePushStatus`,
      payload: {
        key: `${componentName}@updatePushStatus`,
        apiParams: {}
      }
    }
  }
}


let reduxTemplateCofig = (args) => {
  const { record } = args;
  return {
    apis: apis(record),
    componentName,
    initApiKeys: ['list'],
    needLoading: true,
    ...args
  }
};

export { reduxTemplateCofig, templateConfig };
